import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = (isExternalOperator) => {
  const privateCustomerData = isExternalOperator
    ? ''
    : 'lastName'; // здесь только это поле нужно из приватных
  return gql`
    query Customer($id: ID!) {
      customer(id: $id) {
        ${privateCustomerData}
        id
        description
        firstName
        identified
        customInfo {
              label
              value
            }
        cases(status: OPENED, closedActivities: true) {
          id
          name
          description
          messagesCount
          insertedAt
          updatedAt
          lastActivity {
            id
            channelName
            requestType{
              id
              name
            }
          }
          lastNonSystemMessage{
            id
            body
            insertedAt
          }
        }
      }
    }`;
};

function parseCase(item) {
  return {
    ...item,
    title: item.name,
    desc: item.description,
  };
}

function parseCustomer(item) {
  return {
    id: item.id,
    title: item.firstName,
    firstName: item.firstName,
    lastName: item.lastName,
    description: item.description,
    identified: !!item.identified,
    cases: item.cases.map((res) => parseCase(res)),
  };
}

function getCustomer(id, isExternalOperator = false) {
  return apollo.client.query({
    variables: { id },
    query: query(isExternalOperator),
    fetchPolicy: 'network-only',
  }).then((res) => parseCustomer(res.data.customer));
}

export default getCustomer;
